import '@babel/polyfill';
import 'styleguide/styleguide';
import './feature-detects';
import './globals';
import './header';
import './footer';
import './heart';
import 'modules/product-rec-tracking';



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/index.js